import React from 'react';
import ArticleLayout, { Labeled } from '../components/site/ArticleLayout';
import useLang from '../i18n/useLang';
import BlogMESImage from '../images/BlogMES.png';

const BlogMesManufacturing = () => {
  const { t } = useLang();

  return (
    <ArticleLayout
      title={t('blogs.blogMES.header1')}
      image={BlogMESImage}
      imageAlt={t('blogs.blogMES.imageAlt', { defaultValue: t('blogs.blogMES.header1') })}
      imageFit="contain"
      author={t('blogs.blogMaimPage.Yuval')}
      date="2024-11-10"
    >
      <p>{t('blogs.blogMES.IntroParagraph')}</p>

      <h2>{t('blogs.blogMES.header2')}</h2>
      <ul>
        <li><Labeled text={t('blogs.blogMES.feature1')} /></li>
        <li><Labeled text={t('blogs.blogMES.feature2')} /></li>
        <li><Labeled text={t('blogs.blogMES.feature3')} /></li>
        <li><Labeled text={t('blogs.blogMES.feature4')} /></li>
      </ul>

      <h2>{t('blogs.blogMES.header3')}</h2>
      <p>{t('blogs.blogMES.benefitsIntro')}</p>
      <ol>
        <li><Labeled text={t('blogs.blogMES.benefit1')} /></li>
        <li><Labeled text={t('blogs.blogMES.benefit2')} /></li>
        <li><Labeled text={t('blogs.blogMES.benefit3')} /></li>
        <li><Labeled text={t('blogs.blogMES.benefit4')} /></li>
      </ol>

      <h2>{t('blogs.blogMES.header4')}</h2>
      <p>{t('blogs.blogMES.industry4Paragraph')}</p>

      <h2>{t('blogs.blogMES.header5')}</h2>
      <p>{t('blogs.blogMES.conclusionParagraph')}</p>
    </ArticleLayout>
  );
};

export default BlogMesManufacturing;
